// URL of an uploaded file, whatever form MongoDB kept (UP-02, UP-03):
//   /media/<f>, /documents/<f>, /data/images|videos|files/...  (historical,
//   never reached the API in production: nginx answered index.html)
//   /elakay_api/files/<zone>/<f>                                (current)
// Both become `<API origin>/elakay_api/files/<zone>/<f>`, on the host that
// actually serves the API (localhost:2284 in development, www.elakay.com in
// production). External URLs (CDN, YouTube…) and blob:/data: are untouched.
import { elakay_API } from "../config";
import { legacyFilePath } from "./legacyFilePaths";

export { legacyFilePath };

const apiOrigin = () => {
  try { return new URL(elakay_API, window.location.origin).origin; } catch (_) { return window.location.origin; }
};

const isElakayHost = (host) => {
  const hostname = String(host || "").replace(/:\d+$/, "").toLowerCase();
  if (["localhost", "127.0.0.1", "[::1]"].includes(hostname)) return true;
  if (hostname === "elakay.com" || hostname.endsWith(".elakay.com")) return true;
  try {
    return host === new URL(elakay_API, window.location.origin).host || host === window.location.host;
  } catch (_) { return host === window.location.host; }
};

export const toFileUrl = (value) => {
  if (typeof value !== "string") return value;
  const raw = value.trim();
  if (!raw || /^(blob:|data:|#)/i.test(raw)) return value;
  let parsed;
  try { parsed = new URL(raw, window.location.origin); } catch (_) { return value; }
  const relative = raw.startsWith("/") && !raw.startsWith("//");
  // Only Elakay-hosted URLs: relative paths, the API / page host, Elakay
  // domains and loopback hosts (old documents may carry a stale host such as
  // http://localhost:2284). A CDN URL that happens to contain /media/ stays.
  if (!relative && !isElakayHost(parsed.host)) return value;
  const mapped = legacyFilePath(parsed.pathname);
  if (mapped) return `${apiOrigin()}${mapped}${parsed.search}${parsed.hash}`;
  if (parsed.pathname.startsWith("/elakay_api/")) return `${apiOrigin()}${parsed.pathname}${parsed.search}${parsed.hash}`;
  return value;
};
